"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8m0 11.5L7.5 11l1.42-1.41L12 12.67l3.08-3.08L16.5 11z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M15.08 9.59 12 12.67 8.92 9.59 7.5 11l4.5 4.5 4.5-4.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}, "1")], 'ExpandCircleDownTwoTone');